import { CriticalIllnessPlanDetails } from "../../types/plan.types";

const CriticalIllnessPremium: CriticalIllnessPlanDetails = {
	benefit_amount: [10000, 20000, 30000],
	coverage: ["Employee Only", "Employee & Spouse", "Employee & Children", "Employee & Family"],
	coverage_level: ["Without Cancer"],
	premium_amount: {
		standard_premium: {
			"Employee Only": {
				"Without Cancer": {
					10000.0: {
						"18-39": {
							WEEKLY: 0.66,
							MONTHLY: 2.86
						},
						"40-59": {
							WEEKLY: 3.03,
							MONTHLY: 13.13
						},
						"60-64": {
							WEEKLY: 5.13,
							MONTHLY: 22.23
						},
						"65+": {
							WEEKLY: 8.47,
							MONTHLY: 36.7
						}
					},
					20000.0: {
						"18-39": {
							WEEKLY: 1.03,
							MONTHLY: 4.46
						},
						"40-59": {
							WEEKLY: 5.71,
							MONTHLY: 24.74
						},
						"60-64": {
							WEEKLY: 9.92,
							MONTHLY: 42.99
						},
						"65+": {
							WEEKLY: 16.59,
							MONTHLY: 71.89
						}
					},
					30000.0: {
						"18-39": {
							WEEKLY: 1.4,
							MONTHLY: 6.07
						},
						"40-59": {
							WEEKLY: 8.4,
							MONTHLY: 36.4
						},
						"60-64": {
							WEEKLY: 14.71,
							MONTHLY: 63.74
						},
						"65+": {
							WEEKLY: 24.71,
							MONTHLY: 107.08
						}
					}
				},
				"With Cancer": {
					10000.0: {
						"18-39": {
							WEEKLY: 1.12,
							MONTHLY: 4.85
						},
						"40-59": {
							WEEKLY: 5.71,
							MONTHLY: 24.74
						},
						"60-64": {
							WEEKLY: 9.75,
							MONTHLY: 42.25
						},
						"65+": {
							WEEKLY: 15.05,
							MONTHLY: 65.22
						}
					},
					20000.0: {
						"18-39": {
							WEEKLY: 1.94,
							MONTHLY: 8.41
						},
						"40-59": {
							WEEKLY: 11.07,
							MONTHLY: 47.97
						},
						"60-64": {
							WEEKLY: 19.16,
							MONTHLY: 83.03
						},
						"65+": {
							WEEKLY: 29.75,
							MONTHLY: 128.92
						}
					},
					30000.0: {
						"18-39": {
							WEEKLY: 2.77,
							MONTHLY: 12
						},
						"40-59": {
							WEEKLY: 16.44,
							MONTHLY: 71.24
						},
						"60-64": {
							WEEKLY: 28.57,
							MONTHLY: 123.8
						},
						"65+": {
							WEEKLY: 44.46,
							MONTHLY: 192.66
						}
					}
				}
			},
			"Employee & Family": {
				"Without Cancer": {
					10000.0: {
						"18-39": {
							WEEKLY: 1.52,
							MONTHLY: 6.59
						},
						"40-59": {
							WEEKLY: 6.17,
							MONTHLY: 26.74
						},
						"60-64": {
							WEEKLY: 10.3,
							MONTHLY: 44.63
						},
						"65+": {
							WEEKLY: 16.03,
							MONTHLY: 69.46
						}
					},
					20000.0: {
						"18-39": {
							WEEKLY: 2.31,
							MONTHLY: 10.01
						},
						"40-59": {
							WEEKLY: 11.52,
							MONTHLY: 49.92
						},
						"60-64": {
							WEEKLY: 19.77,
							MONTHLY: 85.67
						},
						"65+": {
							WEEKLY: 31.22,
							MONTHLY: 135.29
						}
					},
					30000.0: {
						"18-39": {
							WEEKLY: 3.1,
							MONTHLY: 13.43
						},
						"40-59": {
							WEEKLY: 16.86,
							MONTHLY: 73.06
						},
						"60-64": {
							WEEKLY: 29.24,
							MONTHLY: 126.71
						},
						"65+": {
							WEEKLY: 46.42,
							MONTHLY: 201.15
						}
					}
				},
				"With Cancer": {
					10000.0: {
						"18-39": {
							WEEKLY: 2.46,
							MONTHLY: 10.66
						},
						"40-59": {
							WEEKLY: 11.15,
							MONTHLY: 48.32
						},
						"60-64": {
							WEEKLY: 19.16,
							MONTHLY: 83.03
						},
						"65+": {
							WEEKLY: 28.37,
							MONTHLY: 122.94
						}
					},
					20000.0: {
						"18-39": {
							WEEKLY: 4.18,
							MONTHLY: 18.11
						},
						"40-59": {
							WEEKLY: 21.47,
							MONTHLY: 93.04
						},
						"60-64": {
							WEEKLY: 37.48,
							MONTHLY: 162.41
						},
						"65+": {
							WEEKLY: 55.9,
							MONTHLY: 242.23
						}
					},
					30000.0: {
						"18-39": {
							WEEKLY: 5.91,
							MONTHLY: 25.61
						},
						"40-59": {
							WEEKLY: 31.79,
							MONTHLY: 137.76
						},
						"60-64": {
							WEEKLY: 55.81,
							MONTHLY: 241.84
						},
						"65+": {
							WEEKLY: 83.44,
							MONTHLY: 361.57
						}
					}
				}
			},
			"Employee & Children": {
				"Without Cancer": {
					10000.0: {
						"18-39": {
							WEEKLY: 1.52,
							MONTHLY: 6.59
						},
						"40-59": {
							WEEKLY: 6.17,
							MONTHLY: 26.74
						},
						"60-64": {
							WEEKLY: 10.3,
							MONTHLY: 44.63
						},
						"65+": {
							WEEKLY: 16.03,
							MONTHLY: 69.46
						}
					},
					20000.0: {
						"18-39": {
							WEEKLY: 2.31,
							MONTHLY: 10.01
						},
						"40-59": {
							WEEKLY: 11.52,
							MONTHLY: 49.92
						},
						"60-64": {
							WEEKLY: 19.77,
							MONTHLY: 85.67
						},
						"65+": {
							WEEKLY: 31.22,
							MONTHLY: 135.29
						}
					},
					30000.0: {
						"18-39": {
							WEEKLY: 3.1,
							MONTHLY: 13.43
						},
						"40-59": {
							WEEKLY: 16.86,
							MONTHLY: 73.06
						},
						"60-64": {
							WEEKLY: 29.24,
							MONTHLY: 126.71
						},
						"65+": {
							WEEKLY: 46.42,
							MONTHLY: 201.15
						}
					}
				},
				"With Cancer": {
					10000.0: {
						"18-39": {
							WEEKLY: 2.46,
							MONTHLY: 10.66
						},
						"40-59": {
							WEEKLY: 11.15,
							MONTHLY: 48.32
						},
						"60-64": {
							WEEKLY: 19.16,
							MONTHLY: 83.03
						},
						"65+": {
							WEEKLY: 28.37,
							MONTHLY: 122.94
						}
					},
					20000.0: {
						"18-39": {
							WEEKLY: 4.18,
							MONTHLY: 18.11
						},
						"40-59": {
							WEEKLY: 21.47,
							MONTHLY: 93.04
						},
						"60-64": {
							WEEKLY: 37.48,
							MONTHLY: 162.41
						},
						"65+": {
							WEEKLY: 55.9,
							MONTHLY: 242.23
						}
					},
					30000.0: {
						"18-39": {
							WEEKLY: 5.91,
							MONTHLY: 25.61
						},
						"40-59": {
							WEEKLY: 31.79,
							MONTHLY: 137.76
						},
						"60-64": {
							WEEKLY: 55.81,
							MONTHLY: 241.84
						},
						"65+": {
							WEEKLY: 83.44,
							MONTHLY: 361.57
						}
					}
				}
			},
			"Employee & Spouse": {
				"Without Cancer": {
					10000.0: {
						"18-39": {
							WEEKLY: 1.52,
							MONTHLY: 6.59
						},
						"40-59": {
							WEEKLY: 6.17,
							MONTHLY: 26.74
						},
						"60-64": {
							WEEKLY: 10.3,
							MONTHLY: 44.63
						},
						"65+": {
							WEEKLY: 16.03,
							MONTHLY: 69.46
						}
					},
					20000.0: {
						"18-39": {
							WEEKLY: 2.31,
							MONTHLY: 10.01
						},
						"40-59": {
							WEEKLY: 11.52,
							MONTHLY: 49.92
						},
						"60-64": {
							WEEKLY: 19.77,
							MONTHLY: 85.67
						},
						"65+": {
							WEEKLY: 31.22,
							MONTHLY: 135.29
						}
					},
					30000.0: {
						"18-39": {
							WEEKLY: 3.1,
							MONTHLY: 13.43
						},
						"40-59": {
							WEEKLY: 16.86,
							MONTHLY: 73.06
						},
						"60-64": {
							WEEKLY: 29.24,
							MONTHLY: 126.71
						},
						"65+": {
							WEEKLY: 46.42,
							MONTHLY: 201.15
						}
					}
				},
				"With Cancer": {
					10000.0: {
						"18-39": {
							WEEKLY: 2.46,
							MONTHLY: 10.66
						},
						"40-59": {
							WEEKLY: 11.15,
							MONTHLY: 48.32
						},
						"60-64": {
							WEEKLY: 19.16,
							MONTHLY: 83.03
						},
						"65+": {
							WEEKLY: 28.37,
							MONTHLY: 122.94
						}
					},
					20000.0: {
						"18-39": {
							WEEKLY: 4.18,
							MONTHLY: 18.11
						},
						"40-59": {
							WEEKLY: 21.47,
							MONTHLY: 93.04
						},
						"60-64": {
							WEEKLY: 37.48,
							MONTHLY: 162.41
						},
						"65+": {
							WEEKLY: 55.9,
							MONTHLY: 242.23
						}
					},
					30000.0: {
						"18-39": {
							WEEKLY: 5.91,
							MONTHLY: 25.61
						},
						"40-59": {
							WEEKLY: 31.79,
							MONTHLY: 137.76
						},
						"60-64": {
							WEEKLY: 55.81,
							MONTHLY: 241.84
						},
						"65+": {
							WEEKLY: 83.44,
							MONTHLY: 361.57
						}
					}
				}
			}
		}
	}
};

export const CRITICAL_ILLNESS_PREMIUM = CriticalIllnessPremium;
